import {StatusType} from 'models/StatusTypes';
import {Box, Text, View} from 'native-base';
import {useEffect} from 'react';

import PanelContainer from 'components/PanelContainer';

const OptInClose: React.FunctionComponent = () => {
  const upperDescriptionText = '';
  const lowerDescriptionText = '';

  return (
    <PanelContainer isDialogBox={false} hideCloseBtn={true}>
      <View
        justifyContent="center"
        alignItems="center"
        bgColor="ghostWhite"
        overflow="hidden"
        flex={1}
        paddingX="40px"
        paddingY="30px"
        borderRadius="4px"
        style={{
          shadowColor: '#000',
          shadowOffset: {height: 1, width: 0},
          shadowOpacity: 0.1,
          shadowRadius: 3,
          elevation: 2,
        }}
      >
        <Box justifyContent="center" alignItems="center">
          <Text
            textAlign="center"
            fontFamily="heading"
            fontWeight="700"
            fontSize="22px"
            lineHeight="35px"
            mt="24px"
            mb="16px"
            color="tuna"
          >
            Please close this window to return to your Account
          </Text>
        </Box>
      </View>
    </PanelContainer>
  );
};

export default OptInClose;
